module.exports = __webpack_public_path__ + "static/media/app-logo.7d181980.svg";